<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="应用版本号" prop="AppVersion">
                <el-input size="small" v-model="model.AppVersion" auto-complete="off" placeholder="请输入应用版本号" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="版本跳转路径" prop="AppUrl" >
                <el-input size="small" v-model="model.AppUrl" auto-complete="off" placeholder="请输入版本跳转路径" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="版本安装包" prop="AppDownLoadUrl" v-if="AppType !='web'">
                <el-upload
                    class="upload-demo"
                    action=""
                    :on-change="handleDownloadUrlChange"
                    :http-request="handleHttpRequestDownload"
                    :on-exceed="handleDownloadOver"
                    :limit="limitDownload"
                    :file-list="fileDownloadUrlList"
                    accept=".apk,.exe"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">文件类型只能是.apk或者.exe类型的</div>
                </el-upload>
                <p v-if="this.model.AppDownLoadUrl">应用安装包路径：{{this.model.AppDownLoadUrl}}</p>
            </el-form-item>
            <el-form-item label="版本更新日志">
                <el-input type="textarea" v-model="model.AppUpdateLog" placeholder="请输入版本更新日志" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="版本说明">
                <el-input type="textarea" v-model="model.ReleaseNote" placeholder="请输入版本说明" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {AddAppLog} from '../../../api/app'
import {Upload} from '../../../api/common'
export default {
    data() {
        return {
            title: '新增应用版本',
            name: 'add',
            limitDownload: 1,
            baseURL: window.Global.baseURL,
            model: {
                AppID: null, //配置项名称
                AppVersion: '',   //配置项英文key
                AppUrl: '',
                AppDownLoadUrl: '',
                AppUpdateLog: '',
                ReleaseNote: ''//限制100字
            },
            rules: {
                AppVersion: [{ required: true, message: '请输入应用版本号', trigger: 'blur' }],
                AppUrl: [{ required: true, message: '请输入版本跳转路径', trigger: 'blur' }],
                // AppUpdateLog: [{ required: true, message: '请输入版本更新日志', trigger: 'blur' }],
                // ReleaseNote: [{ required: true, message: '请输入版本说明', trigger: 'blur' }],
            },
            fileDownloadUrlList: [],
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        AppID: {
            required: true
        },
        AppType: {
            required: true
        }
    },  
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.model.AppID = this.AppID;
        },
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.AddAppLog()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeAddDialog')
        },
        AddAppLog() {
            AddAppLog(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
        handleDownloadUrlChange(file,fileList) {
            this.fileDownloadUrlList = fileList.slice(-1);
        },
        handleDownloadOver() {
            this.$message({
                message: '只能上传一个文件',
                type: 'error'
            });
        },
        handleHttpRequestDownload(a) {
            var formdata = new FormData();
            formdata.append('file',a.file)
            Upload(formdata).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '文件上传成功',
                        type: 'success'
                    });
                    this.model.AppDownLoadUrl = this.baseURL + data.data.filePath;
                }
            })
        },
    }
}
</script>

<style>

</style>